import React from 'react'
import {
  HashRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'
import { Spinner } from 'thicket/packages/thicket-elements'
import Loadable from 'react-loadable'

const Wrap = props => <div
  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  }}
>
  <Spinner />
</div>

const AsyncApp = Loadable({
  loader: () => import("../App"),
  loading: Wrap
})
const AsyncWelcome = Loadable({
  loader: () => import("../Welcome"),
  loading: Wrap
})

export default props => <Router>
  <Switch>
    <Redirect exact from="/" to="welcome" />
    <Route exact path="/welcome" render={props =>
      <AsyncWelcome {...props} />} />
    <Route path="/" render={ownProps =>
      <AsyncApp
        {...props}
        {...ownProps}
      />} />
  </Switch>
</Router>



// WEBPACK FOOTER //
// ./src/Mapper/index.js